import { Observable } from 'rxjs'

import { request, parseAPIError } from '../../common/api'

import * as actionTypes from './actionTypes'
import * as actionCreators from './actionCreators'

// Fetch

const fetchReportCustomerTurnoversEpic = action$ =>
    action$.ofType(actionTypes.FETCH).switchMap(action => {
        const requestParams = {
            method: 'GET',
            path: `report-customer-turnovers?month=${action.payload.month}&filters=${JSON.stringify(action.payload.filters)}`,
        }

        return Observable.concat(
            Observable.of({
                type: actionTypes.FETCH_STARTED,
            }),
            request(requestParams)
                .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportCustomerTurnoversFulfilled(ajaxResponse.response)))
                .catch(error => Observable.of(actionCreators.fetchReportCustomerTurnoversRejected(parseAPIError(error))))
                .takeUntil(action$.ofType(actionTypes.FETCH_CANCELLED, actionTypes.FETCH))
        )
    })

export default [fetchReportCustomerTurnoversEpic]
